import { InfoCircle } from '@aktiia/design-system';
import { useTranslation } from 'react-i18next';

import { ModalName } from '../../../enums';
import { useOpenModal } from '../../../features/modals/hooks';

export const BpClassHeader = () => {
  const { t } = useTranslation();
  const openBloodPressureClassModal = useOpenModal(ModalName.BP_CLASS);

  return (
    <div className="flex items-center">
      <span className="mr-2">{t('patient.table.bpClass')}</span>
      <InfoCircle
        className="bloodPressureClassInfoBtn cursor-pointer scale-75"
        onClick={() => openBloodPressureClassModal()}
      />
    </div>
  );
};
